import React from 'react';
import {Document, Font} from '@react-pdf/renderer';
import {getPdfFonts} from "../../utils/themePdfUtils";
import {getThemeName} from "../../utils/themeUtils";
import { t } from '@lingui/core/macro';
import AMBLuggageTagPage from './AMBLuggageTagPage';
import { InfoPart, LuggageTagPage } from './luggageTagsCommon';
import CFCLuggageTagPage from './CFCLuggageTagPage';

Font.register({
    family: "pdfFont",
    fonts: getPdfFonts(),
});

// prevent hyphenation - this is a bit overkill registering it on all elements, it can also be done on component level
Font.registerHyphenationCallback(word => {
    return [word];
});


function LuggageTagPdf(props) {
    return (
        <Document title={t({id: "luggage_tag"})}>
            {props.passengers.map((passenger, index) =>
                <ThemablePaxLuggageTags
                    key={passenger.passengerId}
                    passenger={passenger}
                    bookingData={props.bookingData}
                    passengerNr={index}
                />
            )}
        </Document>
    );
}

export default LuggageTagPdf;

function ThemablePaxLuggageTags(props) {
    const themeName = getThemeName();
    const generateDisembarkation = !!(props.passenger.disembarkationText);
    switch (themeName) {
        case "acl":
            return <>
                <AMBLuggageTagPage type="embarkation" tagLabel="Embarkation" {...props} />

                {generateDisembarkation && <AMBLuggageTagPage type="disembarkation" tagLabel="Disembarkation" {...props} /> }

                {props.passenger.wheelchairTag && <AMBLuggageTagPage type="wheelchair" isWheelchair={true} {...props} /> }
            </>;
        case "cfc":
            return <>
                <CFCLuggageTagPage type="embarkation" tagLabel="Embarquement" {...props} />

                {generateDisembarkation && <CFCLuggageTagPage type="disembarkation" tagLabel="Débarquement" {...props} /> }

                {props.passenger.wheelchairTag && <CFCLuggageTagPage type="wheelchair" isWheelchair={true} {...props} /> }
            </>;
        default:
            return <LuggageTagPage
                {...props}
                mainContentTop={
                    <InfoPart
                        passenger={props.passenger}
                        bookingData={props.bookingData}
                        rotate={true}
                        stepLetter="E"
                    />
                }
                mainContentBottom={
                    <InfoPart
                        passenger={props.passenger}
                        bookingData={props.bookingData}
                        stepLetter="B"
                    />
                }
            />;
    }
}